import { IconBus16, IconWalk16 } from '@cian/ui-kit';
import { UIText1, UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './GeoTravelTime.css';
import { ETransportType } from 'shared/types/geo';

interface IGeoTravelTimeProps {
  transportType: ETransportType;
  time: string;
  small?: boolean;
}

export const GeoTravelTime: React.FC<IGeoTravelTimeProps> = ({ transportType, time, small }) => {
  const Icon = transportType === ETransportType.Walk ? IconWalk16 : IconBus16;
  const Component = small ? UIText2 : UIText1;

  return (
    <div className={styles['container']}>
      <div data-name={transportType} className={styles['icon']}>
        <Icon display="block" color="icon-secondary-default" />
      </div>

      <Component display="inline" color="gray60_100">
        {time}
      </Component>
    </div>
  );
};
